import { render, staticRenderFns } from "./profile.view.vue?vue&type=template&id=736fbba0&scoped=true&"
import script from "./profile.view.ts?vue&type=script&lang=ts&"
export * from "./profile.view.ts?vue&type=script&lang=ts&"
import style0 from "./profile.view.vue?vue&type=style&index=0&id=736fbba0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fbba0",
  null
  
)

export default component.exports